import { injectGlobal } from '@bd/bdui-styles/emotion';
import colors from './colors';

const typography = {
  SansSerif: '\'Muli\', sans-serif',
  Display: '\'Qwigley\', cursive',
};

injectGlobal(`
  body {
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    font-family: ${typography.SansSerif};
  }

  ${
    typography.SansSerif &&
    `
      .text-sans-serif {
        font-family: ${typography.SansSerif}
      }
    `
  }

  ${
    typography.SansSerif &&
    `
      .text-serif {
        font-family: ${typography.SansSerif}
      }
    `
  }

  ${
    typography.SansSerif &&
    `
      .text-display {
        font-family: ${typography.SansSerif}
      }
    `
  }

  a {
    color: ${colors.color1};
    &:hover {
      text-decoration: none;
      color: ${colors.color1Darkest};
    }
  }

  .GlobalSection_heading {
    text-align: center;
    margin: 0 0 30px 0;
  }
`);

export default typography;



// WEBPACK FOOTER //
// ./src/styles/typography.js